export default "__VITE_ASSET__CgIcUuWb__"